export const useStyles = () => {
  return {
    fullAvatarImg: {
      height: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  };
};
